var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.globalModule[_vm.globalGetters.GET_LOADING])?_c('message-overlay',{attrs:{"text":"Authenticating","timer":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }